import { faCreditCardAlt } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { PaymentMethodIcon } from '#src/components/paymentMethods/Icon/index.tsx';

export const NewCreditCard = () => {
  return (
    <Horizontal gap={1}>
      <PaymentMethodIcon icon={faCreditCardAlt} />
      <BodyM color="var(--c-white)">
        <FormattedMessage
          id="NewPaymentBox.methods.newCreditCard"
          defaultMessage="New credit card"
        />
      </BodyM>
    </Horizontal>
  );
};
